import PropTypes from 'prop-types';
import React from 'react';
import { Trans } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import ListView from '../../../base/ListView';
import { toImmutable } from '../../../libs/immutable-transformer';
import { defaultCrewProps, defaultSuccess } from '../../../libs/utils';
import { deleteParkingRequest, unclaimParking } from '../../../services/api/parkingsRequests';
import { getParkingRequests, getRegistrationParkings } from '../../../services/api/registrationParkings';

class _ParkingStickers extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      parkingLimits: undefined,
      parkingRequests: undefined,
      parkingRequestsMeta: undefined,
      parkingRequestsFilters: toImmutable({
        'page[number]': 1,
        'page[size]': 1000,
        'sort': '-updated_at',
        'include':
          'parking,crew-member,crew-member.user,parking-request-parking-stickers,parking-request-parking-stickers.parking-sticker,handledByUser',
      }),
    };

    this._getParkings = this._getParkings.bind(this);
    this._getLimits = this._getLimits.bind(this);
    this._handleDelete = this._handleDelete.bind(this);
  }

  static propTypes = {
    ...defaultCrewProps,
    admin: PropTypes.bool,
  };

  UNSAFE_componentWillMount() {
    const registration = this.props.registration;
    this.setState({ registration });

    this._getParkings();
    this._getLimits();
  }

  _getParkings(filters = this.state.parkingRequestsFilters) {
    const registration = this.props.registration;
    getParkingRequests(registration.id, filters).then((response) => {
      let stickers = [];
      for (let i = 0; i < response.data.length; i++) {
        const newStickers = [...response.data[i].parkingRequestParkingStickers];
        for (let j = 0; j < newStickers.length; j++) {
          newStickers[j].crewMember = response.data[i].crewMember;
          newStickers[j].parking = response.data[i].parking;
        }

        stickers = stickers.concat(newStickers);
      }

      response.meta.to = stickers.length;
      response.meta.total = stickers.length;

      this.setState({
        parkingRequests: stickers,
        parkingRequestsMeta: response.meta,
      });
    });
  }

  _getLimits() {
    const registration = this.props.registration;
    getRegistrationParkings(registration.id, {
      include: 'parking,parking.parking-stickers',
    }).then((response) => {
      this.setState({
        parkingLimits: response.data,
      });
    });
  }

  _handleDelete(id) {
    const eventId = this.props.registration.eventId;
    const item = this.state.parkingRequests?.find((pr) => pr.id === id);
    if (!!item?.claimedAt) {
      unclaimParking(eventId, id).then((response) => {
        this._getParkings();
        this._getLimits();
        defaultSuccess('Request unclaimed');
      });
    } else {
      alert('Cannot Unclaim a request that has not been claimed');
    }
  }

  render() {
    const { parkingRequestsFilters, parkingRequests, parkingRequestsMeta } = this.state;
    const { registration } = this.props;

    const listViewConf = {
      dataSet: parkingRequests,
      dataMeta: parkingRequestsMeta,
      columns: [
        {
          key: 'crewMember.id',
          value: 'Crew Member',
          render: (request) => request.crewMember.user.firstName + ' ' + request.crewMember.user.lastName,
        },
        {
          key: 'parking.name',
          value: 'Parking',
        },
        {
          key: 'parkingSticker.name',
          value: 'Sticker',
        },
        {
          key: 'claimedAt',
          value: 'Redeemed',
        },
        {
          key: 'code',
          value: 'Code',
        },
      ],
      filters: [
        {
          label: 'Name',
          icon: 'la-search',
          type: 'text',
          key: 'user_name',
        },
      ],
      baseFilters: parkingRequestsFilters,
      actions: {
        deleteLink: true,
        deleteLabel: 'Unclaim',
        deleteHideFunction: (item) => {
          return !item?.claimedAt;
        },
        editLink: false,
        detailsLink: false,

        deleteFunction: this._handleDelete,
        customLink: this._zonesBtn,
      },
      url: '/admin/registrations/' + registration.id + '/edit/crew',
    };

    return (
      <div className="row">
        <div className="col-xl-12">
          <div className="row">
            <div className="col-lg-12">
              {parkingRequests ? (
                <ListView
                  config={listViewConf}
                  handleDelete={this._handleDelete}
                  handleFilterUpdate={this._getParkings}
                />
              ) : (
                <div className="alert alert-info">
                  <Trans>frontend.crew.noRegistrationParkingRequestsMsg</Trans>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({});

const mapStateToProps = function (state) {
  return {};
};

const ParkingStickers = withRouter(connect(mapStateToProps, mapDispatchToProps)(_ParkingStickers));

export default ParkingStickers;
